import type { CacheConfig, RequestParameters, Variables } from 'relay-runtime';

declare const process: {
	env?: {
		AGG_BRANCH_SLUG: string | undefined;
		AGG_SERVICE_OVERRIDES: string | undefined;
	};
};

const branchSlug =
	typeof process !== 'undefined' && process.env ? process.env.AGG_BRANCH_SLUG : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const serviceOverrides =
	typeof process !== 'undefined' && process.env ? process.env.AGG_SERVICE_OVERRIDES : undefined;
export const aggPathname: string = `/gateway/api/graphql${branchSlug ? `/${branchSlug}/graphql` : ''}`;

export const getAggEndpoint = (
	request: RequestParameters,
	cacheConfig: CacheConfig = {},
): string => {
	let endpoint = aggPathname;
	if (cacheConfig.metadata?.META_SLOW_ENDPOINT) {
		endpoint = `${endpoint}/slow`;
	}
	if (request.id != null) {
		endpoint = `${endpoint}/pq/${request.id}`;
	}

	let url = `${endpoint}?operation=${request.name}`;
	if (serviceOverrides) {
		url = `${url}&serviceOverride=${serviceOverrides}`;
	}

	return url;
};

export const getRequestBody = (request: RequestParameters, variables: Variables): string => {
	const requestBody: {
		operationName: string;
		variables: Variables;
		query?: string | null | undefined;
	} = {
		operationName: request.name,
		variables,
	};

	return JSON.stringify(requestBody);
};
